import { render } from "./releasedNumbers.vue?vue&type=template&id=6196356c&scoped=true"
import script from "./releasedNumbers.vue?vue&type=script&lang=js"
export * from "./releasedNumbers.vue?vue&type=script&lang=js"

import "./releasedNumbers.vue?vue&type=style&index=0&id=6196356c&scoped=true&lang=scss"
import "./releasedNumbers.vue?vue&type=style&index=1&id=6196356c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6196356c"]])

export default __exports__